module.exports = "https://static.wmbcdn.com/uniweb/images/22939f200d6dc31e02a94ffa48068ea1.svg";